import { css as r } from "@microsoft/fast-element";
import { display as e } from "@matrix42/fast-foundation";
import { normalize as i } from "../../common/normalize.js";
import { designTokens as o } from "../../design-tokens.js";
const p = r`
  ${i}
  ${e("flex")}
  :host {
    /* Layout */
    gap: ${o.spacing["2.5"]};
  }

  ::slotted(.selected-value) {
    /* Layout */
    display: flex;
    padding: 0 ${o.spacing[2]};
    align-items: center;
    gap: ${o.spacing[1]};
    /* Style */
    border-radius: ${o.borderRadius.full};
    background-color: ${o.color.primary[30]};
    color: ${o.color.primary[100]};
    /* Typography */
    font-weight: ${o.fontWeight.semibold};
  }
`;
export {
  p as listboxValuesStyles
};
